'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationSuccess = undefined;

var _RegistrationSuccess2 = require('./RegistrationSuccess');

var _RegistrationSuccess3 = _interopRequireDefault(_RegistrationSuccess2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RegistrationSuccess = _RegistrationSuccess3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationSuccess/index.js
// module id = 1757
// module chunks = 0